import { useEffect } from "react";
import { colorPalettes } from "../utils/colorPalettes";

export const useColorTheme = () => {
  useEffect(() => {
    // Get all available color palette names
    const colorNames = Object.keys(colorPalettes);

    // Check if a specific color is set via environment variable
    const envColor = process.env.REACT_APP_SELECTED_COLOR;
    let selectedColorName;

    if (
      envColor &&
      envColor.trim() !== "" &&
      colorPalettes[envColor.toLowerCase()]
    ) {
      // Use the color specified in environment variable
      selectedColorName = envColor.toLowerCase();
    } else {
      // Randomly select a color palette
      const randomIndex = Math.floor(Math.random() * colorNames.length);
      selectedColorName = colorNames[randomIndex];
    }

    const selectedPalette = colorPalettes[selectedColorName];

    // Set CSS variables for all 11 shades (using indices 0-9, mapped to 1-10)
    selectedPalette.shades.forEach((shade, index) => {
      const variableName = `--primary-color-${index + 1}`;
      document.documentElement.style.setProperty(variableName, shade);

      // Also create rgba version with 0.2 opacity for borders
      // Convert hex to rgb
      const hex = shade.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const rgbaName = `--primary-color-${index + 1}-rgba-02`;
      document.documentElement.style.setProperty(
        rgbaName,
        `rgba(${r}, ${g}, ${b}, 0.2)`
      );
    });

    // Set the named color variable
    document.documentElement.style.setProperty(
      "--primary-color-named",
      selectedPalette.named
    );

    // Optional: Store selected color for debugging
    // console.log('Selected color theme:', selectedColorName);
  }, []); // Run only once on mount
};
